import { useState, useEffect } from "react";
import useTableCtx from "../tableContext/useTableCtx";
import DatePicker from "../../misc/DatePicker";
import { tableDatePickerClasses } from "./tableControlStyles";

const TableDatePicker = ({
  value,
  withDatePicker,
}: {
  value: string;
  withDatePicker:
    | {
        minDate?: Date;
        maxDate?: Date;
        placeholder?: string;
        withClearData?: boolean;
      }
    | boolean;
}) => {
  const { minDate, maxDate, placeholder, withClearData } =
    typeof withDatePicker === "boolean"
      ? {
          minDate: undefined,
          maxDate: undefined,
          placeholder: "",
          withClearData: false,
        }
      : withDatePicker;

  const { handleTableSearch, tableSearch } = useTableCtx()!;
  const contextValue = tableSearch?.[value];

  const [pickedDate, setPickedDate] = useState<Date | null>(
    contextValue ? new Date(contextValue) : null,
  );

  useEffect(() => {
    handleTableSearch(value, pickedDate?.toISOString() ?? "");
  }, [handleTableSearch, pickedDate, value]);

  return (
    <DatePicker
      textInputClassName={tableDatePickerClasses}
      size="small"
      isRequired
      gutterBottom={false}
      minDate={minDate}
      maxDate={maxDate}
      value={pickedDate}
      placeholder={placeholder}
      withClearData={withClearData}
      handleChangeDate={(value) => setPickedDate(value)}
    />
  );
};

export default TableDatePicker;
